import { Box, ButtonBase } from '@mui/material';
import { TimetableEntity } from 'src/entities/Timetable.entity';

const muted = 'text.secondary';

type Props = {
  timetables: TimetableEntity[];
  /** 選択色にするダイヤ。コースを選んでいる間は null */
  selectedTimetableId: number | null;
  onSelectTimetable: (timetableId: number) => void;
};

/** ダイヤ名と所属コース数だけの行を並べる。所属コースはダイヤ詳細に出す */
export default function TimetableList({ timetables, selectedTimetableId, onSelectTimetable }: Props) {
  return (
    <Box sx={{ flex: 1, overflow: 'auto' }}>
      {timetables.map((t) => {
        const selected = t.id === selectedTimetableId;
        return (
          <ButtonBase
            key={t.id}
            data-testid="timetable-row"
            aria-label={`${t.name}ダイヤを編集`}
            aria-current={selected ? true : undefined}
            onClick={() => onSelectTimetable(t.id)}
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 1.5,
              minHeight: 68,
              borderBottom: 1,
              borderColor: 'divider',
              textAlign: 'left',
              bgcolor: selected ? 'action.selected' : 'background.paper',
              '&:hover': { bgcolor: selected ? undefined : 'action.hover' },
            }}
          >
            <Box component="span" sx={{ fontSize: 13, color: muted, flexShrink: 0 }}>ダイヤ</Box>
            <Box component="span" sx={{ flex: 1, minWidth: 0, fontSize: 16, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {t.name}
            </Box>
            <Box component="span" sx={{ fontSize: 13, color: muted, flexShrink: 0 }}>{t.courseCount}コース</Box>
          </ButtonBase>
        );
      })}
      {timetables.length === 0 && <Box sx={{ p: 2, fontSize: 13, color: muted }}>ダイヤはまだありません</Box>}
    </Box>
  );
}
